import React, { Fragment, useEffect, useState } from "react";
import { FnBlock_UI } from 'components/BlockUI';

import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from "components/FormItem/yupFormSchemas";
import { ColumnProps } from "components/TableUI/TableUI";
import { BtnAddTable, BtnCancel, BtnDeleteTable, BtnEditTable, BtnPDFTable, BtnSearchTable, BtnViewTable } from "components/Button";
import { Chip, Grid, Typography } from "@mui/material";
import TableUI from "components/TableUI";
import { useLocation, useNavigate } from "react-router-dom";
import { SelectFormItem, SelectMultipleFormItem, TextBoxForm } from "components/Input";
import { BsArrowDown, BsArrowDownUp, BsArrowUp } from "react-icons/bs";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import { DatePickerFromItem } from "components/Input/DatePicker";
import { HiChip } from "react-icons/hi";
import { AxiosPost } from "utilities/Axios";
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import { Encrypt, undefinedOrNull } from "utilities/Function";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#0053b5",
        color: theme.palette.common.white,
        border: '1px solid rgba(224, 224, 224, 1) !important',
        padding: '10px',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        padding: '8px',
        border: '1px solid rgba(224, 224, 224, 1) !important',
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

export default function Home() {
    //#region State
    const navigate = useNavigate();
    const { BlockUI, UnBlockUI } = FnBlock_UI();
    const [arrRowData, setarrRowData] = useState([]);
    const [Soring, SetSoring] = useState("");
    const [lstRecruiting, setlstRecruiting] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(500);

    const onSoring = () => {
        let sSort ="";
        if (Soring == "") {
            sSort ="ASC";
            SetSoring("ASC");
        } else if (Soring == "ASC") {
            sSort ="DESC";
            SetSoring("DESC");
        } else if (Soring == "DESC") {
            SetSoring("");
        }
        LoadData(sSort);
    }
    //#endregion

    //#region Column
    const ColumnData: ColumnProps[] = [
        {
            id: "nNo",
            name: "ลำดับ",
            width: "5%",
            cellAlign: "center"
        },
        {
            id: "sUrlImg",
            name: "",
            width: "5%",
            cellAlign: "center"
        },
        {
            id: "sRecruitmentName",
            name: "ชื่อเจ้าหน้าที่สรรหา",
            width: "5%",
            cellAlign: "left"
        },
        {
            id: "sIDCard",
            name: "เลขที่บัตรประชาชน",
            width: "8%",
            cellAlign: "center"
        },
        {
            id: "sName",
            name: "ชื่อ - นามสกุล",
            width: "40%",
            cellAlign: "left"
        },
        {
            id: "sPositionName",
            name: "ตำแหน่งที่สนใจ",
            width: "20%",
            cellAlign: "left"
        },
        {
            id: "nStatusID",
            name: "สถานะ",
            width: "15%",
            cellAlign: "center",
        },
        {
            id: "sRegisterDate",
            name: "วันที่สมัคร",
            width: "15%",
            cellAlign: "center"
        },
        {
            id: "Button",
            name: "",
            width: "8%",
            cellAlign: "center",
        }
    ];

    useEffect(() => {
        BlockUI();
        AxiosPost("Home/PageLoad", {}, (res) => {
            setlstRecruiting(res.lstRecruiting || [])
            setarrRowData(res.lstData || [])
        }, null, null, null, () => {
            UnBlockUI();
        })
    }, []);
    const LoadData = (sSort) => {
        BlockUI();
        let obj = {
            nRecruiting: undefinedOrNull(form.getValues("nRecruitmentID"), "number"),
            sSoring:sSort
        }
        AxiosPost("Home/onLoadData", obj, (res) => {
            setarrRowData(res || [])
        }, null, null, null, () => {
            UnBlockUI();
        })
    }
    //#endregion

    //#region FN
    const onEdit = (sID, sMode) => {
        navigate("/UserRecruitment_From?str=" + Encrypt(sID))
    }

    // const onPDF = (nID) => {
    // }
    //#endregion
    const objSchema = yup.object().shape({
        s1: yupFormSchemas.string("เลขที่ใบสมัคร", { required: false }),
        s2: yupFormSchemas.string("เลขที่บัตรประชาชน", { required: false }),
        sUserName: yupFormSchemas.string("ชื่อ-นามสกุล", { required: false }),
        sDate: yupFormSchemas.datetime("ช่วงวันที่สมัคร", { required: false }),
        sStatus: yupFormSchemas.string("สถานะ", { required: false }),
    });
    const form = useForm({
        resolver: yupResolver(objSchema),
        mode: 'all',
        shouldFocusError: true,
        criteriaMode: "firstError",
    });
    return (
        <Grid container direction="row" xs={12} md={12} spacing={2} marginBottom={1}>
            <FormProvider {...form}>
                <Grid item xs={6} >
                    <Typography style={{ fontSize: '4em', color: '#0E2B6D', marginTop: '-0.7em', marginLeft: '-0.1em' }}></Typography>
                    <Typography style={{ fontSize: '2em', color: '#0E2B6D', fontWeight: 600, marginLeft: '0.6em', marginTop: '0.6em' }}>JOB APPLICATION</Typography>
                    <Typography style={{ fontSize: '1.5em', color: '#0E2B6D', fontWeight: 300, marginTop: '-0.9em', marginLeft: '0.7em' }}>LAST UPDATE</Typography>
                </Grid>
                <Grid item md={5.2} xs={12}>
                    <SelectFormItem options={lstRecruiting || []} name={"nRecruitmentID"} label={"ชื่อเจ้าหน้าที่สรรหา"} />
                </Grid>
                <Grid item >
                    <BtnSearchTable onClick={() => { LoadData(Soring) }} />
                </Grid>
            </FormProvider>
            <Grid item md={12} xs={12}>
                <Paper sx={{ width: '100%' }}>
                    <TableContainer sx={{ maxHeight: 600 }}>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <StyledTableRow>
                                    {ColumnData.map((column) => (
                                        <StyledTableCell
                                            key={column.id}
                                            align={"center"}
                                            style={{ minWidth: column.width }}
                                        >
                                            {column.id === "sRegisterDate" ?
                                                <div style={{ display: "flex", gap: "5px", justifyContent: "center", alignItems: "center" }}>
                                                    {column?.name}
                                                    <div className="butsoring" onClick={onSoring}>
                                                        {Soring == "" && <BsArrowDownUp />}
                                                        {Soring == "ASC" && <BsArrowDown />}
                                                        {Soring == "DESC" && <BsArrowUp />}
                                                    </div>
                                                </div>
                                                : column?.name}
                                        </StyledTableCell>
                                    ))}
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {arrRowData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                                    return (
                                        <StyledTableRow hover role="checkbox" tabIndex={-1} key={row.nID}>
                                            {ColumnData.map((column) => {
                                                const value = row[column.id];
                                                return (
                                                    <>
                                                        {column.id === "Button" ?

                                                            <StyledTableCell key={column.id} align={column.cellAlign}>
                                                                <> {row.isEdit ? (
                                                                    <div style={{ display: "inline-flex", textAlign: "center" }}>
                                                                        {/* <BtnPDFTable title="เอกสาร" onClick={() => onPDF(row.nID)} /> */}
                                                                        <BtnEditTable title="แก้ไขข้อมูล" style={{ marginLeft: "5px" }} onClick={() => onEdit(row.nID, row.sIDCard)} />
                                                                        {/* <BtnViewTable title="รายละเอียด" style={{ marginLeft: "5px" }} onClick={() => onEdit(row.nID, "View")} /> */}
                                                                    </div>
                                                                ) : (<BtnViewTable title="รายละเอียด" style={{ marginLeft: "5px" }} onClick={() => onEdit(row.nID, row.sIDCard)} />)
                                                                }
                                                                </>
                                                            </StyledTableCell>
                                                            :
                                                            (column.id === "nStatusID" ?
                                                                <StyledTableCell key={column.id} align={column.cellAlign}>
                                                                    <>
                                                                        {row.nStatusID === 85 && (
                                                                            <Chip
                                                                                size="small"
                                                                                label={row.sStatusName}
                                                                                style={{
                                                                                    color: "#a55e00",
                                                                                    backgroundColor: "rgb(255 248 233)",
                                                                                    margin: "0.2rem",
                                                                                }}
                                                                            />
                                                                        )}
                                                                    </>
                                                                </StyledTableCell>
                                                                :
                                                                column.id === "sUrlImg" ?
                                                                    <StyledTableCell key={column.id} align={column.cellAlign} style={{ padding: "0" }}>
                                                                        <PhotoProvider>
                                                                            <PhotoView src={row.sUrlImg}>
                                                                                <img src={row.sUrlImg} alt="Paris" width="50" height="50"
                                                                                    style={{
                                                                                        borderRadius: "8%",
                                                                                        boxShadow: "rgb(0, 0, 0, 0.35) 0px 5px 15px;",
                                                                                        marginTop: "6px",
                                                                                        cursor: "pointer"
                                                                                    }}></img>
                                                                            </PhotoView>
                                                                        </PhotoProvider>
                                                                    </StyledTableCell>
                                                                    :
                                                                    <StyledTableCell key={column.id} align={column.cellAlign}>
                                                                        {value}
                                                                    </StyledTableCell>
                                                            )
                                                        }
                                                    </>
                                                );
                                            })}
                                        </StyledTableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Grid>
        </Grid>
    )
}